export const PDF_FILE_EXTENSION = 'pdf';

export enum DOCUMENT_V1_SORTING {
    CREATED_ASC = 'createdAt',
    CREATED_DESC = '-createdAt',
    SORT_FOLDER_FIRST = '-isFolder',
    NAME_ASC = 'name',
    NAME_DESC = '-name',
    AUTHOR_ASC = 'author',
    AUTHOR_DESC = '-author',
}

export enum DOCUMENT_TYPES {
    IMAGE = 'IMAGE',
    FOLDER = 'FOLDER',
    OTHER = 'OTHER',
}

export enum MOVE_DOCUMENT_FOLDER_STATUS {
    ROOT = 'root',
    LOADING = 'loading',
    LOADED = 'loaded',
}

export enum DOCUMENT_FILTERS {
    TAGS = 'tags',
}
